import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {

	PUT_BEST_OFFERS: type('[Best offers] put best offers'),
	PUT_JOURNEYS: type('[Best offers] put best offers journeys'),
	PUT_BEST_OFFERS_FLIGHTS: type('[Best offers] put best offers flights'),
	PUT_BEST_OFFERS_CITY: type('[Best offers] put best offers city'),
	RESET: type('[Best offers] Reset')
};

export class PutBestOffersAction implements Action {
	type = ActionTypes.PUT_BEST_OFFERS;

	/**
	 *Creates an instance of PutLanguageAction.
	 * @param {*} payload
	 * @memberof PutBestOffersAction
	 */
	constructor(public payload: any) { }
}

export class PutBestOffersFlights implements Action {
	type = ActionTypes.PUT_BEST_OFFERS_FLIGHTS;

	/**
	 *Creates an instance of PutLanguageAction.
	 * @param {*} payload
	 * @memberof PutBestOffersFlights
	 */
	constructor(public payload: any) { }
}

export class PutBestOffersCity implements Action {
	type = ActionTypes.PUT_BEST_OFFERS_CITY;


	/**
	 *Creates an instance of PutLanguageAction.
	 * @param {*} payload
	 * @memberof PutBestOffersCity
	 */
	constructor(public payload: any) { }
}
export class PutJourneys implements Action {
	type = ActionTypes.PUT_JOURNEYS;


	/**
	 *Creates an instance of PutJourneys.
	 * @param {*} payload
	 * @memberof PutJourneys
	 */
	constructor(public payload: any) { }
}
export class ResetAction implements Action {
	type = ActionTypes.RESET;
	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions =  PutBestOffersAction | PutBestOffersFlights | PutBestOffersCity| PutJourneys | ResetAction;
